import { Button } from '@vadiun/react-components';
import { useSuperMutation, useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useRef, useState } from 'react';
import PageContainer from '../../../../../layout/components/PageContainer';
import PageHeader from '../../../../../layout/components/PageHeader';
import { ClientPrivateEdit } from '../components/ClientPrivateEdit';
import { ClientPrivateTable } from '../components/ClientPrivateTable';
import { ClientPrivateFormType } from '../forms/ClientPrivateFormType';
import { ClientPrivateModel } from '../models/ClientPrivate';
import useClientPrivates from '../services/ClientPrivateService';
import { createTableScrollHandler } from 'utils/tableUtils';

export function ClientPrivateCrudPage() {
  const tableRef = useRef<HTMLDivElement>(null);
  const ClientPrivateService = useClientPrivates();
  const clientprivatesQuery = useSuperQuery(
    ClientPrivateService.getClientPrivates,
    {
      showSpinner: true
    }
  );
  const updateClientPrivateMutation = useSuperMutation(
    ClientPrivateService.updateClientPrivate
  );
  const removeClientPrivateMutation = useSuperMutation(
    ClientPrivateService.removeClientPrivate,
    {
      showSpinner: true
    }
  );
  const restoreClientPrivateMutation = useSuperMutation(
    ClientPrivateService.restoreClientPrivate,
    {
      showSpinner: true
    }
  );
  const [visiblePage, setVisiblePage] = useState<'table' | 'create' | 'update'>(
    'table'
  );
  const [updatingClientPrivate, setEditingClientPrivate] =
    useState<ClientPrivateModel>();

  async function update(clientprivateValues: ClientPrivateFormType) {
    clientprivateValues.id = updatingClientPrivate!.id;
    await updateClientPrivateMutation.mutate(clientprivateValues);
    setVisiblePage('table');
    clientprivatesQuery.reload();
  }

  async function remove(clientprivate: ClientPrivateModel) {
    await removeClientPrivateMutation.mutate(clientprivate);
    clientprivatesQuery.reload();
  }

  async function restore(clientprivate: ClientPrivateModel) {
    await restoreClientPrivateMutation.mutate(clientprivate);
    clientprivatesQuery.reload();
  }

  function selectToEdit(clientprivate: ClientPrivateModel) {
    setEditingClientPrivate(clientprivate);
    setVisiblePage('update');
  }
  return (
    <div ref={tableRef}>
      <PageHeader
        title="Cliente particulares"
        subArea={
          visiblePage === 'table'
            ? 'Listado de Clientes particulares'
            : 'Editar Cliente'
        }
        toolbar={
          visiblePage !== 'table' && (
            <Button onClick={() => setVisiblePage('table')} variant="light">
              Volver
            </Button>
          )
        }
      />

      <PageContainer>
        {visiblePage === 'table' && (
          <ClientPrivateTable
            handlePageChange={createTableScrollHandler(tableRef)}
            clientprivates={clientprivatesQuery.data || []}
            selectToEdit={selectToEdit}
            delete={remove}
            restore={restore}
          />
        )}

        {visiblePage === 'update' && updatingClientPrivate && (
          <ClientPrivateEdit
            update={update}
            initialValues={updatingClientPrivate}
          />
        )}
      </PageContainer>
    </div>
  );
}
